// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"b18f96d607baf5dc","4544":"aa7ed8b47a9a70ba"}[chunkId] + ".css";
};